<template>
    <div style="width: 100%">
        <div class="login-form-container__element--right -padding-bottom">
            <div class="log-reg-form--register validation-fields-container" novalidate spellcheck="false">
                <h2 class="log-reg-form__heading">{{ $t('DO_YOU_HAVE_ACCOUNT_REGISTER') }}</h2>
                <ul class="log-reg-form__column">
                    <li class="log-reg-form__list">
                        <div id="registryValidationContainer" class="validation-texts-container">
                            <p
                                class="validation-texts-container__text validation-texts-container__text--required-fields"
                            >
                                {{ $t('FILL_CORRECTLY_ALL_FIELDS') }}
                            </p>
                            <p
                                class="validation-texts-container__text validation-texts-container__text--wrong-login-data"
                            >
                                {{ $t('SET_SAVE_PASSWORD') }}
                            </p>
                            <p class="validation-texts-container__text validation-texts-container__text--wrong-code">
                                {{ $t('PASSWORDS_MUST_BE_THE_SAME') }}
                            </p>
                        </div>
                        <div v-if="serverValidationErrors.length > 0">
                            <p class="validate-danger" v-for="error in serverValidationErrors">
                                <img src="./../../../assets/images/icons/excl-red.svg" /> {{ error }}
                            </p>
                        </div>
                        <div v-if="illegalCharacters.length > 0">
                            <p class="validate-danger">
                                <img src="./../../../assets/images/icons/excl-red.svg" />
                                {{
                                    $t('ILLEGAL_CHARACTERS', { characters: "'" + illegalCharacters.join("', '") + "'" })
                                }}
                            </p>
                        </div>
                        <div v-if="proCodeErrorMessage">
                            <p class="validate-danger">
                                <img src="./../../../assets/images/icons/excl-red.svg" /> {{ proCodeErrorMessage }}
                            </p>
                        </div>
                    </li>
                    <li class="log-reg-form__list">
                        <input
                            v-model.trim="registryData.firstName"
                            @keyup="inputKeyUp"
                            :placeholder="$t('FIRST_NAME')"
                            type="text"
                            maxlength="50"
                            class="log-reg-form__input text-input -grey-input half-input-length"
                            required
                            :class="{ invalid: !firstNameIsValid && formSubmitted }"
                        />
                    </li>
                    <li class="log-reg-form__list">
                        <input
                            v-model.trim="registryData.lastName"
                            @keyup="inputKeyUp"
                            :placeholder="$t('LAST_NAME')"
                            type="text"
                            maxlength="50"
                            class="log-reg-form__input text-input -grey-input half-input-length"
                            required
                            :class="{ invalid: !lastNameIsValid && formSubmitted }"
                        />
                    </li>
                    <li class="log-reg-form__list">
                        <input
                            v-model.trim="registryData.email"
                            @keyup="inputKeyUp"
                            :placeholder="$t('EMAIL_ADDRESS')"
                            required
                            type="text"
                            class="validate-email log-reg-form__input text-input -grey-input"
                        />
                    </li>
                    <li class="log-reg-form__list">
                        <div class="row">
                            <div class="col-xs-4 pr-2">
                                <el-select id="directionalNumber" v-model="registryData.dialingCode">
                                    <el-option
                                        v-for="item in directionalNumbers"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-xs-8 pl-0">
                                <input
                                    v-model.trim="registryData.phone"
                                    @keyup="inputKeyUp"
                                    :placeholder="$t('PHONE_NUMBER')"
                                    required
                                    type="tel"
                                    class="log-reg-form__input -margin-bottom text-input -grey-input"
                                />
                            </div>
                        </div>
                    </li>
                    <li class="log-reg-form__list log-reg-form__list--save-password">
                        {{ $t('SAVE_PASSWORD_SHOULD') }}
                    </li>
                    <li class="log-reg-form__list">
                        <input
                            v-model="registryData.password"
                            @keyup="inputKeyUp"
                            :placeholder="$t('PASSWORD')"
                            type="password"
                            required
                            class="log-reg-form__input text-input validate-password validate-password-first -grey-input"
                        />
                    </li>
                    <li class="log-reg-form__list">
                        <input
                            v-model="registryData.passwordRepeat"
                            @keyup="inputKeyUp"
                            :placeholder="$t('REPEAT_PASSWORD')"
                            type="password"
                            required
                            class="log-reg-form__input text-input validate-password validate-password-second -grey-input"
                        />
                    </li>
                    <li class="log-reg-form__list">
                        <div class="row">
                            <span class="col-xs-5 type-of-account-span">{{ $t('TYPE_OF_ACCOUNT') }}</span>
                        </div>
                        <div class="row mx-1">
                            <label class="fake-label">
                                <input
                                    class="custom-input"
                                    type="radio"
                                    :value="false"
                                    name="radio"
                                    v-model="registryData.accountTypeIsPro"
                                />
                                <span class="input-container">{{ $t('ACCOUNT_TYPE_PERSONAL') }}</span>
                                <span class="checkmark"></span>
                            </label>
                            <label class="fake-label">
                                <input
                                    class="custom-input"
                                    type="radio"
                                    :value="true"
                                    name="radio"
                                    v-model="registryData.accountTypeIsPro"
                                />
                                <span class="input-container">{{ $t('ACCOUNT_TYPE_PROFESSIONAL') }}</span>
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="row mt-2">
                            <span class="col-xs-5 type-of-account-span">{{ $t('COUNTRY') }}</span>
                            <div class="col-xs-7 pl-0">
                                <el-select
                                    id="country-select"
                                    filterable
                                    v-model="registryData.territoryId"
                                    :filter-method="filterOptions"
                                >
                                    <el-option
                                        v-for="territory in filteredTerritories"
                                        :key="territory.id"
                                        :label="territory.name"
                                        :value="territory.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </li>
                    <li class="log-reg-form__list">
                        <div class="row">
                            <span class="col-xs-5 type-of-account-span">{{ $t('ACTIVATION_CODE') }}</span>
                            <div class="col-xs-7 pl-0">
                                <input
                                    v-model="registryData.code"
                                    @keyup="inputKeyUp"
                                    class="log-reg-form__input text-input -grey-input"
                                    :class="{ invalid: proCodeErrorMessage !== '' }"
                                />
                            </div>
                        </div>
                    </li>
                    <li v-if="proExternalDocumentationIsRequired" class="log-reg-form__list--check">
                        <label class="checkbox -checkbox-long">
                            <input
                                v-model="registryData.proExternalDocumentation"
                                @change="inputKeyUp"
                                class="checkbox__check-input validate-checkbox"
                                required
                                type="checkbox"
                                name=""
                            />
                            <span class="checkbox__check -grey-border-checkbox"></span>
                            <span class="checkbox__text -black-checkbox-text log-reg-form__checkbox-text">{{
                                $t('OWNER_MEDICAL_DOC')
                            }}</span>
                        </label>
                    </li>
                    <li class="log-reg-form__list--check">
                        <label class="checkbox -checkbox-long">
                            <input
                                v-model="registryData.rulesAgreement"
                                @change="inputKeyUp"
                                class="checkbox__check-input validate-checkbox"
                                required
                                type="checkbox"
                                name=""
                            />
                            <span class="checkbox__check -grey-border-checkbox"></span>
                            <span class="checkbox__text -black-checkbox-text log-reg-form__checkbox-text"
                                >{{ $t('I_ACCEPT') }}
                                <a class="log-reg-form__link" :href="eSklepUrl + $t('LINK_TERMS')" target="_blank">{{
                                    $t('PRO_ACCOUNT_RODO_TERMS')
                                }}</a>
                            </span>
                        </label>
                    </li>
                    <li class="log-reg-form__list--check">
                        <label class="checkbox -checkbox-long">
                            <input
                                v-model="registryData.commercialAgreement"
                                class="checkbox__check-input"
                                required
                                type="checkbox"
                                name=""
                            />
                            <span class="checkbox__check -grey-border-checkbox"></span>
                            <span class="checkbox__text -black-checkbox-text log-reg-form__checkbox-text">{{
                                $t('REGISTRY_NEWSLETTER_AGREEMENT')
                            }}</span>
                        </label>
                    </li>
                    <li class="log-reg-form__list--check">
                        <label class="checkbox -checkbox-long">
                            <input
                                v-model="registryData.marketingAgreement"
                                class="checkbox__check-input"
                                required
                                type="checkbox"
                                name=""
                            />
                            <span class="checkbox__check -grey-border-checkbox"></span>
                            <span class="checkbox__text -black-checkbox-text log-reg-form__checkbox-text">{{
                                $t('MARKETING_INFORMATION_AGREEMENT')
                            }}</span>
                        </label>
                    </li>
                    <li class="log-reg-form__list">
                        <button
                            @click="registry"
                            id="registryBtn"
                            class="buttons-container__button -button-red validate-test validate-button"
                        >
                            {{ $t('REGISTRY') }}
                        </button>
                    </li>
                    <li class="log-reg-form__list--check log-reg-form__list--agreement">
                        <span v-html="$t('DATA_ADMINISTRATOR_REGISTER')"></span>
                        <a :href="eSklepUrl + $t('LINK_TERMS')">{{ eSklepUrl + $t('LINK_TERMS') }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { config } from './../../../main';
import { directionalNumbers } from './../../../countries';
import { validate, validateEmail } from './../../../validation';
import { alphabeticSortByName, illegalCharactersInWord } from './../../../utils';

export default {
    data() {
        return {
            registryData: {
                firstName: '',
                lastName: '',
                email: '',
                dialingCode: '+48',
                phone: '',
                documentLanguage: this.$store.state.interfaceLanguage,
                interfaceLanguage: this.$store.state.interfaceLanguage,
                password: '',
                passwordRepeat: '',
                territoryId: null,
                code: '',
                commercialAgreement: false,
                marketingAgreement: false,
                rulesAgreement: false,
                isOwnerMedicalDoc: false,
                accountTypeIsPro: false,
            },
            formSubmitted: false,
            firstNameIsValid: true,
            lastNameIsValid: true,
            directionalNumbers,
            serverValidationErrors: [],
            proCodeErrorMessage: '',
            illegalCharacters: [],
            eSklepUrl: config.eSklepUrl,
            filteredTerritories: null,
        };
    },
    computed: {
        proExternalDocumentationIsRequired() {
            const selectedTerritory =
                this.territories && this.territories.find(i => i.id === this.registryData.territoryId);
            return this.registryData.accountTypeIsPro && selectedTerritory && !selectedTerritory.collectAdditionalData;
        },
    },
    asyncComputed: {
        territories() {
            return this.$http
                .get('/user/public/registration/territories')
                .then(({ data }) => data.sort(alphabeticSortByName));
        },
        filteredTerritories() {
            this.filteredTerritories = this.territories;
        },
    },
    methods: {
        filterOptions(filterValue) {
            let filteredTerritories = this.territories.filter(territory => {
                return territory.name.toLowerCase().startsWith(filterValue.toLowerCase());
            });

            if (filterValue === null) {
                this.filteredTerritories = this.territories;
            } else {
                this.filteredTerritories = filteredTerritories;
            }
        },
        registry() {
            if (this.performValidation()) {
                this.$http.post('/user/public/registration/register/', this.registryData).then(
                    response => {
                        this.$emit('accountCreated');
                        this.$http
                            .post(
                                config.eSklepUrl + '/pl/sociallogin/mojekonto/login',
                                {
                                    email: response.body.email,
                                    id: response.body.numericId,
                                    first_name: response.body.firstName,
                                    last_name: response.body.lastName,
                                },
                                {
                                    emulateJSON: true,
                                },
                            )
                            .then(() => this.activateProCode(response.body));
                    },
                    error => {
                        this.serverValidationErrors = [];
                        error.body.forEach(({ field, message }) => {
                            if (field === 'email') {
                                this.serverValidationErrors.push(this.$t('SERVER_ERROR_EMAIL'));
                            }
                            if (field === 'brasterCode') {
                                if (message === 'CODE_ALREADY_ASSIGNED')
                                    this.proCodeErrorMessage = this.$i18n.t('CODE_ALREADY_USED');
                                if (message === 'CODE_EXPIRED')
                                    this.proCodeErrorMessage = this.$i18n.t('CODE_ALREADY_EXPIRED');
                                if (message === 'NO_SUCH_CODE')
                                    this.proCodeErrorMessage = this.$i18n.t('INVALID_CODE_INSERTED');
                                if (message === 'BAD_TERRITORY')
                                    this.proCodeErrorMessage = this.$i18n.t('BAD_ACCOUNT_TYPE');
                                if (message === 'BAD_PRODUCT_LINE')
                                    this.proCodeErrorMessage = this.$i18n.t('BAD_ACCOUNT_TYPE');
                                if (message === 'CODE_BLOCKED')
                                    this.proCodeErrorMessage = this.$i18n.t('INVALID_CODE_INSERTED');
                                if (message === 'The braster code was not understood.')
                                    this.proCodeErrorMessage = this.$i18n.t('BAD_ACCOUNT_TYPE');
                            }
                        });
                    },
                );
            }
            this.formSubmitted = true;
        },
        performValidation() {
            this.checkNamesValidation();
            const emailIsValid = validateEmail(this.registryData.email);
            const phoneIsValid =
                this.registryData.phone &&
                illegalCharactersInWord(config.numbersOnlyRegex, this.registryData.phone).length === 0;
            return (
                validate($('#registryBtn')) &&
                this.firstNameIsValid &&
                this.lastNameIsValid &&
                emailIsValid &&
                phoneIsValid
            );
        },
        inputKeyUp() {
            this.serverValidationErrors = [];
            this.proCodeErrorMessage = '';
            this.registryData.phone = this.registryData.phone.replace(config.numbersOnlyRegex, '');
            if (this.formSubmitted) {
                return this.performValidation();
            }
        },
        checkNamesValidation() {
            const firstName = this.registryData.firstName;
            const firstNameInvalidCharacters = illegalCharactersInWord(config.nameRegex, firstName);
            this.firstNameIsValid = firstName && firstNameInvalidCharacters.length === 0;
            const lastName = this.registryData.lastName;
            const lastNameInvalidCharacters = illegalCharactersInWord(config.nameRegex, lastName);
            this.lastNameIsValid = lastName && lastNameInvalidCharacters.length === 0;
            this.illegalCharacters = [...new Set([...firstNameInvalidCharacters, ...lastNameInvalidCharacters])];
        },
        activateProCode(user) {
            if (this.registryData.accountTypeIsPro) {
                const url = config.eSklepUrl + '/pl/mojekonto/api';
                const json = JSON.stringify({
                    mail: user.email,
                    key: this.registryData.code,
                    dateStart: this.$moment().format('YYYY-MM-DD'),
                });
                this.$http.post(url, { id: json }, { emulateJSON: true }).then(() => {});
            }
        },
    },
};
</script>

<style lang="scss">
.invalid {
    border: 2px solid red;
}

#directionalNumber,
#type-of-account-select,
#country-select {
    height: 54px;
}

.type-of-account-span {
    padding: 14px 0 14px 24px;
    font-size: 18px;
}

@media (max-width: 991px) {
    #directionalNumber,
    #type-of-account-select,
    #country-select {
        height: 40.5px !important;
    }

    .type-of-account-span {
        padding: 10px 0 10px 24px;
        font-size: 14px;
    }
}

.fake-label {
    max-width: none;
}
</style>



// WEBPACK FOOTER //
// registry.vue?60c3da7c